import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DATALAKE_CONTRAPARTE_PATH } from 'src/utils/api-routes'
import ParameterDatalakeContraparteTable from 'src/pages/parameters/parameters-datalake/tables/parameter-datalake-contraparte-table'

const TableContraparte = ({ loading, empresa }) => {
    const PAGE_DEFAULT_SIZE = 25
    const PAGE_DEFAULT_INIT = 0
    const [pagination] = useState({ init: PAGE_DEFAULT_INIT, end: PAGE_DEFAULT_SIZE })

    return <ParameterDatalakeContraparteTable
        customFilter={false}
        disableToolbar={true}
        filters={[{field: 'CPFCNPJ', value: empresa}]}
        endpoint={`${DATALAKE_CONTRAPARTE_PATH}?`}
        loading={loading} 
        pagination={pagination}/>
}

TableContraparte.propTypes = {
    loading: PropTypes.func,
    empresa: PropTypes.object
}

export default TableContraparte